export let Spec = /*#__PURE__*/function (Spec) {
  Spec["NewResultsPerPageDefaultValue"] = "specs.siteSearch.NewResultsPerPageDefaultValue";
  Spec["ProGallery"] = "specs.siteSearch.ProGallery";
  Spec["UseWarmupData"] = "specs.siteSearch.UseWarmupData";
  Spec["SearchResultsPageProductsSlot"] = "specs.siteSearch.SearchResultsPageProductsSlot";
  Spec["ProductResultFromStoreFront"] = "specs.siteSearch.ProductResultFromStoreFront";
  Spec["ChangeSelectedTabInEditorOnEdit"] = "specs.siteSearch.ChangeSelectedTabInEditorOnEdit";
  Spec["CSSPerBreakpointIndications"] = "specs.siteSearch.CSSPerBreakpointIndications";
  return Spec;
}({});
//# sourceMappingURL=specs.js.map